import { Certification } from '@/services/types/accredit'
import { getImage } from '@/utils/utils'
import dayjs from 'dayjs'
import React, { useEffect, useRef } from 'react'

const width = 350
const height = 500
const MID_X = width / 2 / width
const NUM_Y = 66 / height
const NUM_X = 222 / width
const PHOTO_Y = 155 / height
const PHOTO_X = 145 / width
const PHOTO_WIDTH = 60 / width
const PHOTO_HEIGHT = 75 / height
const NAME_Y = 260 / height
const BIRTHDAY_Y = 287 / height
const BIRTHDAY_X = 247 / height
const GRADE_Y = 340 / height

const RELEASE_Y = 394.5 / height
const YEAR_X = 222 / width
// const MONTH_X = 255 / width
// const DAY_X = 273 / width

const getBirthday = (idCard: string) => {
  var birthday = ''
  if (idCard !== null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = '19' + idCard.substr(6, 6)
    } else if (idCard.length === 18) {
      birthday = idCard.substr(6, 8)
    }

    // birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
  }

  return birthday
}

const getGrade = (grade: number) => {
  const list = {
    13: '十三',
    14: '十四',
    15: '十五',
    16: '十六',
  } as any
  return (list[grade] || list['16']) + '级棋士'
}

type TSTProps = {
  certificate: Certification
  canvasId: string
}

const screenWidth = document.body.clientWidth
const CERT_WIDTH = 1724
const CERT_HEIGHT = 2551
const CERT_RATIO = CERT_WIDTH / CERT_HEIGHT
const CERT_SCREEN_WIDTH = Math.floor(screenWidth - 60)
const CERT_SCREEN_HEIGHT = Math.floor(CERT_SCREEN_WIDTH / CERT_RATIO)
const dpr = 1724 / CERT_SCREEN_WIDTH

const CertPic: React.FC<TSTProps> = ({ certificate, canvasId }: TSTProps) => {
  const canvasWidth = useRef(0)
  const canvasHeight = useRef(0)
  // const [certPicPath, setCertPicPath] = useState('')

  useEffect(() => {
    setTimeout(async () => {
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D

      // const dpr = Taro.getSystemInfoSync().pixelRatio
      canvas.width = CERT_WIDTH
      canvas.height = CERT_HEIGHT
      canvasWidth.current = CERT_WIDTH
      canvasHeight.current = CERT_HEIGHT
      // 背景
      // const background = document.getElementById('certBg') as HTMLImageElement
      const background = new Image()
      background.src = require('./cert_bg.jpg')
      background.crossOrigin = 'anonymous'
      background.onload = () => {
        ctx.drawImage(background, 0, 0, canvasWidth.current, canvasHeight.current)
        ctx.restore()
        // 编号
        ctx.fillStyle = '#c01c21'
        ctx.font = `${8 * dpr}px 黑体`
        ctx.fillText(
          'No.' + certificate.certification_num,
          NUM_X * canvasWidth.current,
          NUM_Y * canvasHeight.current,
        )
        // 姓名
        ctx.fillStyle = '#000'
        ctx.font = `bold ${12 * dpr}px 黑体`
        ctx.textAlign = 'center'
        ctx.fillText(certificate.name, MID_X * canvasWidth.current, NAME_Y * canvasHeight.current)
        // 称号
        ctx.fillText(
          getGrade(certificate.grade),
          MID_X * canvasWidth.current,
          GRADE_Y * canvasHeight.current,
        )
        // 生日
        ctx.textAlign = 'left'
        ctx.font = `${11 * dpr}px 黑体`
        ctx.fillText(
          certificate.birthday.replaceAll('-', '.') || getBirthday(certificate.identification_num),
          BIRTHDAY_X * canvasWidth.current,
          BIRTHDAY_Y * canvasHeight.current,
        )
        // 发证日期
        ctx.font = `${7 * dpr}px 黑体`
        const releaseDate = dayjs(new Date(certificate.release_date)).format('YYYY 年 MM 月 DD 日')
        // if (releaseDate.length === 3) {
        //   ctx.fillText(releaseDate[0], YEAR_X * canvasWidth.current, RELEASE_Y * canvasHeight.current)
        //   ctx.fillText(releaseDate[1], MONTH_X * canvasWidth.current, RELEASE_Y * canvasHeight.current)
        //   ctx.fillText(releaseDate[2], DAY_X * canvasWidth.current, RELEASE_Y * canvasHeight.current)
        // }
        console.log(releaseDate)
        ctx.fillText(releaseDate, YEAR_X * canvasWidth.current, RELEASE_Y * canvasHeight.current)
        // 头像
        // const photo = document.getElementById(String(certificate.id)) as HTMLImageElement
        const photo = new Image()
        photo.src = getImage(certificate.photo) + '&v=' + Math.random()
        photo.crossOrigin = 'anonymous'
        photo.onload = () => {
          ctx.drawImage(
            photo,
            PHOTO_X * canvasWidth.current,
            PHOTO_Y * canvasHeight.current,
            PHOTO_WIDTH * canvasWidth.current,
            PHOTO_HEIGHT * canvasHeight.current,
          )
        }
        // const photo = new Image()
        // photo.setAttribute('crossOrigin', 'anonymous')
        // photo.src = getImage(certificate.photo)
        // photo.addEventListener(
        //   'load',
        //   () => {
        //   },
        //   false,
        // )
      }
    }, 500) // 不延迟无法通过query拿到node
  }, [])

  if (certificate === undefined) {
    return null
  }

  return (
    <>
      <div
        id="certImg"
        style={{
          marginTop: 50,
          width: CERT_SCREEN_WIDTH,
          height: CERT_SCREEN_HEIGHT,
          backgroundColor: 'rgba(255, 255, 255, .3)',
        }}
      >
        <canvas
          style={{
            width: CERT_SCREEN_WIDTH,
            height: CERT_SCREEN_HEIGHT,
          }}
          id={canvasId}
        ></canvas>
      </div>
      {/* <img
        src={certPicPath}
        style={{ marginTop: 50, width: CERT_SCREEN_WIDTH, height: CERT_SCREEN_HEIGHT }}
        alt=""
      /> */}
      {/* <img
        id={String(certificate.id)}
        style={{
          position: 'absolute',
          top: '10000px',
          width: CERT_SCREEN_WIDTH,
          height: CERT_SCREEN_HEIGHT,
        }}
        src={getImage(certificate.photo)}
        alt=""
      /> */}
    </>
  )
}

export default CertPic
